import { input } from '@angular/core';
import * as i0 from "@angular/core";
function UpdateWatchlistConfirmationDetailsComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 0);
    i0.ɵɵtext(1);
    i0.ɵɵdomElementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r0.details().error);
} }
function UpdateWatchlistConfirmationDetailsComponent_Conditional_1_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 3)(1, "span", 2);
    i0.ɵɵtext(2, "Rename to:");
    i0.ɵɵdomElementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵdomElementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1(" ", ctx_r0.details().rename_to);
} }
function UpdateWatchlistConfirmationDetailsComponent_Conditional_1_Conditional_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 3)(1, "span", 2);
    i0.ɵɵtext(2);
    i0.ɵɵdomElementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵdomElementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Adding (", ctx_r0.details().added_symbols.length, "):");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.details().added_symbols.join(", "), " ");
} }
function UpdateWatchlistConfirmationDetailsComponent_Conditional_1_Conditional_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 3)(1, "span", 2);
    i0.ɵɵtext(2);
    i0.ɵɵdomElementEnd();
    i0.ɵɵtext(3);
    i0.ɵɵdomElementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Removing (", ctx_r0.details().removed_symbols.length, "):");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.details().removed_symbols.join(", "), " ");
} }
function UpdateWatchlistConfirmationDetailsComponent_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 1)(1, "div", 2);
    i0.ɵɵtext(2);
    i0.ɵɵdomElementEnd();
    i0.ɵɵconditionalCreate(3, UpdateWatchlistConfirmationDetailsComponent_Conditional_1_Conditional_3_Template, 4, 1, "div", 3);
    i0.ɵɵconditionalCreate(4, UpdateWatchlistConfirmationDetailsComponent_Conditional_1_Conditional_4_Template, 4, 2, "div", 3);
    i0.ɵɵconditionalCreate(5, UpdateWatchlistConfirmationDetailsComponent_Conditional_1_Conditional_5_Template, 4, 2, "div", 3);
    i0.ɵɵdomElementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.details().current_name);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.details().rename_to ? 3 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.details().added_symbols.length ? 4 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.details().removed_symbols.length ? 5 : -1);
} }
export class UpdateWatchlistConfirmationDetailsComponent {
    constructor() {
        this.details = input.required(...(ngDevMode ? [{ debugName: "details" }] : []));
    }
}
UpdateWatchlistConfirmationDetailsComponent.ɵfac = function UpdateWatchlistConfirmationDetailsComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || UpdateWatchlistConfirmationDetailsComponent)(); };
UpdateWatchlistConfirmationDetailsComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: UpdateWatchlistConfirmationDetailsComponent, selectors: [["ycn-update-watchlist-confirmation-details"]], inputs: { details: [1, "details"] }, decls: 2, vars: 1, consts: [[1, "text-large", "leading-relaxed", "mb-3", "text-danger"], [1, "text-large", "leading-relaxed", "mb-3"], [1, "font-bold"], [1, "mt-2"]], template: function UpdateWatchlistConfirmationDetailsComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵconditionalCreate(0, UpdateWatchlistConfirmationDetailsComponent_Conditional_0_Template, 2, 1, "div", 0)(1, UpdateWatchlistConfirmationDetailsComponent_Conditional_1_Template, 6, 4, "div", 1);
    } if (rf & 2) {
        i0.ɵɵconditional(ctx.details().error ? 0 : 1);
    } }, encapsulation: 2, changeDetection: 0 });
